import axios from "axios";

export const modifyForm = (form) => ({
  type: 'MODIFY_FORM',
  form,
});

export const startModifyForm = (formData = {}) => {
  return (dispatch) => {
    const {
      name = formData.name,
      isCarer = formData.isCarer,
      serviceType = formData.serviceType,
      patientAge = formData.patientAge,
      patientGender = formData.patientGender,
      patientLivingArrangements = formData.patientLivingArrangements,
      patientPostcode = formData.patientPostcode,
      patientTransportToHospital = formData.patientTransportToHospital,
      patientTransportOther = formData.patientTransportOther,
      patientEthnicity = formData.patientEthnicity,
      patientGenderIdentity = formData.patientGenderIdentity,
      patientGenderAtBirth = formData.patientGenderAtBirth,
      patientSexualOrientation = formData.patientSexualOrientation,
      safeSevenOne = formData.safeSevenOne,
      safeSevenTwo = formData.safeSevenTwo,
      safeSevenThree = formData.safeSevenThree,
      safeSevenFour = formData.safeSevenFour,
      safeSevenFive = formData.safeSevenFive,
      safeSevenSix = formData.safeSevenSix,
      safeSevenSeven = formData.safeSevenSeven,
      patientGoodExperience = formData.patientGoodExperience,
      patientBadExperience = formData.patientBadExperience,
      formState = formData.formState,
      key = formData.key,
      allowServiceTypeSelect = formData.allowServiceTypeSelect || false,
    } = formData;

    const form = {
      name,
      isCarer,
      serviceType,
      patientAge,
      patientGender,
      patientLivingArrangements,
      patientPostcode,
      patientTransportToHospital,
      patientTransportOther,
      patientEthnicity,
      patientGenderIdentity,
      patientGenderAtBirth,
      patientSexualOrientation,
      safeSevenOne,
      safeSevenTwo,
      safeSevenThree,
      safeSevenFour,
      safeSevenFive,
      safeSevenSix,
      safeSevenSeven,
      patientGoodExperience,
      patientBadExperience,
      formState,
      key,
      allowServiceTypeSelect,
    };
    if (form.formState !== 'start') {
      localStorage.setItem('safe7', JSON.stringify(form));
    }
    dispatch(
        modifyForm({
          ...form,
        })
    );
  };
};

// Language actions
export const setLanguage = (language) => ({
  type: 'SET_LANGUAGE',
  language
});

export const setTranslations = (translations) => ({
  type: 'SET_TRANSLATIONS',
  translations
});

export const setLoading = (isLoading) => ({
  type: 'SET_LOADING',
  isLoading
});

export const clearUserLanguage = () => {
  return (dispatch) => {
    dispatch({
      type: 'CLEAR_LANGUAGE'
    });
  };
};


export const changeLanguage = (language) => {
  return async (dispatch) => {
    dispatch(setLanguage(language));
    dispatch(setLoading(true));

    // Fetch new translations
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/language/${language}.json`);

      if (response.data && response.data.success && response.data.data) {
        dispatch(setTranslations(response.data.data));
      } else {
        console.error('Invalid translation data format', response.data);
      }
    } catch (error) {
      console.error(`Failed to fetch translations for ${language}:`, error);
    } finally {
      dispatch(setLoading(false));
    }
  };
};

// export const setTokenLanguage = (tokenLanguage) => ({
//   type: 'SET_TOKEN_LANGUAGE',
//   tokenLanguage
// });
//
// // Initialize translations for the current language
// export const initializeLanguage = () => {
//   return async (dispatch, getState) => {
//     const userSelectedLang = localStorage.getItem("userSelectedLang");
//
//     if (userSelectedLang) {
//       // Use the user's manually selected language
//       dispatch(changeLanguage(userSelectedLang));
//     } else {
//       // Default to English if no user selection
//       // The API language will override this in JourneyWrapper
//       dispatch(changeLanguage("en"));
//     }
//   };
// };

export const setLanguageFromToken = (language) => {
  return (dispatch) => {
    // Update store without affecting localStorage
    dispatch(changeLanguage(language || "en"));
  };
};
